import React from 'react'
import { Classes, Button } from '@blueprintjs/core'
import ProvidersTripsTable from './providerTripsTable'
import { getTrips, getTrip } from '../../services/tripApiService';
import { TRIP_STATUS, CSV_CONFIG, DATE_FORMAT, ERROR_TOAST_ICON,
	CLIENTS, LEVELS, STATES, SPECIALITIES,FROM_TO_DATE_TIME} from '../../../utils/Constants';
import {
	providerTripsContainer, flexCenter,
	tripsHeaderContainer, tripsSpan,
	tripsHeaderSubcontainer, refreshButtonContainer, csvLinkContainer,
	footerButtonsContainer, exportFileButton, backToTopButton, suggestContainer,
	suggestProviderComponentStyle, searchButtonWidth, popoverContainerDiv
} from '../../styles'
import LoadingSpinner from '../../loadingSpinner';
import { AppToaster } from "../../toastComponent";
import TripsDetailsComponent from '../tripDetails/tripsDetailsComponent'
import SuggestProviderComponent from './suggestProviderComponent'
import moment from 'moment';
import InfiniteScroll from 'react-infinite-scroller';
import { CSVLink } from 'react-csv';
import './styles.css';
import TripStatusFilterModal, { getTripStatus } from './../modalComponents/tripStatusFilterModal';
import FilterModal, { getFilters, getSpecialtyFilter,getDateTimeFilter} from '../modalComponents/filterModal'

const localserviceArea = JSON.parse(localStorage.getItem('serviceAreaCheckboxs'));
const localclientOptions = JSON.parse(localStorage.getItem('clientOptionsCheckboxs'));
const locallevelOptions = JSON.parse(localStorage.getItem('levelOptionsCheckboxs'));
const localspecialtyOptions = JSON.parse(localStorage.getItem('specialtyOptionsCheckboxs'));
const localFromToDateTime = JSON.parse(localStorage.getItem('fromToDateTimeValues'));

export default class ProvidersContainer extends React.Component {
	constructor(props) {
		super(props);
		this.csvLink = React.createRef();
		this.state = {
			offsetCount: 0,
			tripsTop: 100,
			isLoadMoreVisible: false,
			isLoadMoreDisabled: true,
			trips: [],
			filteredTrips: [],
			selectedProvider: null,
			dueTimeAfterTripLocalTime: moment().toDate(),
			dueTimeBeforeTripLocalTime: moment().toDate(),
			selectedTrip: null,
			selectedRow: null,
			isLoading: false,
			serviceAreaCheckboxs: localserviceArea ? localserviceArea : STATES,
			clientOptionsCheckboxs: localclientOptions ? localclientOptions : CLIENTS,
			levelOptionsCheckboxs: locallevelOptions ? locallevelOptions : LEVELS,
			specialtyOptionsCheckboxs: localspecialtyOptions ? localspecialtyOptions : SPECIALITIES,
			fromToDateTimeValues : localFromToDateTime ? localFromToDateTime : FROM_TO_DATE_TIME,
			sortBy: 'DueTime',
			sortOrder: 'ASC',
			tableRef: React.createRef(),
			tripStatusCheckboxs: TRIP_STATUS,
			csvTrips: [],
			csvOffset: 0,
			csvTop: 1000,
			allTripsSearched: false,
			csvLoading: false,
			isLoadingKeyEvents: false,
			isLoadingDetails: false
		};
	}

	handleBackToTopClick = () => {
		this.state.tableRef.current.scrollIntoView({
			block: 'start',
			behavior: 'smooth',
		});
	}

	handleScroll = (event) => {
		this.setState({
			isLoadMoreVisible: event.target.scrollTop > 0 ? true : false,
		})
	}

	handleLoadMore = async () => {
		if (this.state.trips.length === 0) {
			return;
		}

		var offsetCount = this.state.offsetCount + 1;

		await this.setState({
			isLoadMoreDisabled: true,
			isLoading: true,
		});
		await this.getTrips(offsetCount);
	}

	handleProviderChange = (provider) => {
		this.setState({
			selectedProvider: provider,
			isLoadMoreDisabled: true,
			allTripsSearched: false,
			csvOffset: 0,
			csvTrips: []
		})
	}

	handleDateRangeChange = (dateRange) => {
		this.setState({
			dueTimeAfterTripLocalTime: dateRange[0],
			dueTimeBeforeTripLocalTime: dateRange[1],
			isLoadMoreDisabled: true,
			allTripsSearched: false,
			csvOffset: 0,
			csvTrips: []
		});
	}

	refreshFilters = async () => {
		const serviceArea = JSON.parse(localStorage.getItem('serviceAreaCheckboxs'));
		const clientOptions = JSON.parse(localStorage.getItem('clientOptionsCheckboxs'));
		const levelOptions = JSON.parse(localStorage.getItem('levelOptionsCheckboxs'));
		const specialtyOptions = JSON.parse(localStorage.getItem('specialtyOptionsCheckboxs'));
		const FromToDateTime = JSON.parse(localStorage.getItem('fromToDateTimeValues'));
		await this.setState({
			serviceAreaCheckboxs: serviceArea? serviceArea : this.state.serviceAreaCheckboxs,
			clientOptionsCheckboxs: clientOptions? clientOptions: this.state.clientOptionsCheckboxs,
			levelOptionsCheckboxs: levelOptions? levelOptions : this.state.levelOptionsCheckboxs,
			specialtyOptionsCheckboxs: specialtyOptions? specialtyOptions: this.state.specialtyOptionsCheckboxs,
			fromToDateTimeValues:  FromToDateTime? FromToDateTime: this.state.fromToDateTimeValues
		});
		//  await this.setState({
		// 	serviceAreaCheckboxs: JSON.parse(localStorage.getItem('serviceAreaCheckboxs')),
		// 	clientOptionsCheckboxs: JSON.parse(localStorage.getItem('clientOptionsCheckboxs')),
		// 	levelOptionsCheckboxs: JSON.parse(localStorage.getItem('levelOptionsCheckboxs')),
		// 	specialtyOptionsCheckboxs: JSON.parse(localStorage.getItem('specialtyOptionsCheckboxs')),
		// 	fromToDateTimeValues:  JSON.parse(localStorage.getItem('fromToDateTimeValues'))
		// });
	}

	getTrips = async (offsetCount) => {

		if(this.state.fromToDateTimeValues.some((dateTime) => !dateTime.date || !dateTime.time )){
			AppToaster.show({ message: "From/To Date and Time are required", intent: "danger", timeout: '7000', icon: ERROR_TOAST_ICON });
			this.setState({
				isLoading: false,
				isOpenFilter: true
			});
      
			this.setState({isOpenFilter: null});
			return;
		}

		try {
			const offset = this.state.tripsTop * offsetCount;
			const providerId = this.state.selectedProvider?.providerId;
			const stateFilter = getFilters(this.state.serviceAreaCheckboxs);
			const clientFilter = getFilters(this.state.clientOptionsCheckboxs);
			const levelFilter = getFilters(this.state.levelOptionsCheckboxs);
			const status = getTripStatus(this.state.tripStatusCheckboxs);
			var isVip = getSpecialtyFilter(this.state.specialtyOptionsCheckboxs, "isVip");
			var isOversizeWC = getSpecialtyFilter(this.state.specialtyOptionsCheckboxs, "isOversizeWC");
			var isDialysis = getSpecialtyFilter(this.state.specialtyOptionsCheckboxs, "isDialysis");
			var fromDateTime = getDateTimeFilter(this.state.fromToDateTimeValues, "fromDateTime");
			var toDateTime = getDateTimeFilter(this.state.fromToDateTimeValues, "toDateTime");
			
			let trips = this.state.trips;
			let newTrips = [];

			const params = {
				top: this.state.tripsTop, offset: offset, state: stateFilter, sortBy: this.state.sortBy, 
				sortOrder: this.state.sortOrder, dueTimeBeforeTripLocalTime: toDateTime, dueTimeAfterTripLocalTime: fromDateTime,
				providerId: providerId, status: status, client: clientFilter, serviceLevel: levelFilter, isVip: isVip, 
				WheelchairType: isOversizeWC, dialysis: isDialysis
			}
			
			Object.keys(params).forEach((key) => (params[key] == null || params[key] === '') && delete params[key]);

			if (this.state.selectedProvider === null) {
				AppToaster.show({ message: 'Provider is required.', intent: "danger", timeout: '7000', icon: ERROR_TOAST_ICON });

				this.setState({
					isLoading: false,
				});

				return;
			}

			newTrips = await getTrips(params);

			if (newTrips.length === 0) {
				AppToaster.show({ message: 'No trips found.', intent: "danger", timeout: '7000', icon: ERROR_TOAST_ICON });

				return;
			}

			trips = trips.concat(newTrips);

			this.setState({
				offsetCount: offsetCount,
				trips: trips,
				isLoadMoreDisabled: newTrips.length < this.state.tripsTop ? true : false,
			});
		}
		catch (error) {
			console.log(error);
		}
		finally {
			this.setState({
				isLoading: false,
			});
		}
	}

	setSelectedTrip = async (e) => {
		try {
			if (e.currentTarget !== this.state.selectedRow) {
				const tripNumber = e.currentTarget.getAttribute('id');
				if (this.state.selectedRow != null) {
					const selectedRow = this.state.selectedRow;
					selectedRow.bgColor = '';

					this.setState({
						selectedRow: selectedRow,
						isLoadingDetails: true,
						isLoadingKeyEvents: true
					})
				}

				const currentTarget = e.currentTarget;
				currentTarget.bgColor = this.props.themeName === Classes.DARK ? '#00000020' : '#cccccc';

				this.setState({
					selectedRow: currentTarget
				})

				const trip = await getTrip(tripNumber);

				await this.setState({
					selectedTrip: trip,
					isLoadingDetails: false
				});
			}
		}
		catch (error) {
			console.log(error);
			let message = 'Unexpected error.';

			if (error.response?.status === 404) {
				message = 'No trip found.';
			}
			AppToaster.show({ message: message, intent: "danger", timeout: '7000', icon: ERROR_TOAST_ICON });
		}
	}

	refreshTrips = async (sortBy, sortOrder,onPressFilterModal) => {
		await this.setState({
			isLoadMoreVisible: false,
			isLoadMoreDisabled: true,
			offsetCount: 0,
			trips: [],
			csvTrips: [],
			csvOffset: 0,
			selectedTrip: null,
			isLoading: true,
			sortBy: sortBy,
			sortOrder: sortOrder
		});
		
		if(!onPressFilterModal){
			await this.refreshFilters();
		}

		this.getTrips(this.state.offsetCount);
	}

	handleFilter = async () => {
		this.refreshTrips(this.state.sortBy, this.state.sortOrder,true);
	}

	getCsvFilename = () => {
		if (this.state.selectedProvider !== null) {
			const fromDate = this.state.fromToDateTimeValues.find(dateTime => dateTime.name === "fromDateTime").date;
			const toDate = this.state.fromToDateTimeValues.find(dateTime => dateTime.name === "toDateTime").date;
			const fromDateFormatString = moment(new Date(fromDate + " 00:00")).format(DATE_FORMAT);
			const toDateFormatString = moment(new Date(toDate + " 00:00")).format(DATE_FORMAT);

			return `${this.state.selectedProvider.providerName}_${fromDateFormatString}-${toDateFormatString}.csv`;
		}
		return '';
	}
	componentDidMount() {
		this.props.handleHeaderPathChange('Provider');
	}

	handleKeySpinner() {
		this.setState({ isLoadingKeyEvents: false });
	}

	exportCsv = async () => {
		
		await this.refreshFilters();
		this.setState({ csvLoading: true });

		while (!this.state.allTripsSearched) {
			try {

				if(this.state.fromToDateTimeValues.some((dateTime) => !dateTime.date || !dateTime.time )){
					AppToaster.show({ message: "From/To Date and Time are required", intent: "danger", timeout: '7000', icon: ERROR_TOAST_ICON });
					this.setState({
						csvLoading: false,
						isOpenFilter: true
					});

					this.setState({isOpenFilter: null});
					return;
				}
				
				const providerId = this.state.selectedProvider?.providerId;
				const stateFilter = getFilters(this.state.serviceAreaCheckboxs);
				const clientFilter = getFilters(this.state.clientOptionsCheckboxs);
				const levelFilter = getFilters(this.state.levelOptionsCheckboxs);
				const status = getTripStatus(this.state.tripStatusCheckboxs);
				var isVip = getSpecialtyFilter(this.state.specialtyOptionsCheckboxs, "isVip");
				var isOversizeWC = getSpecialtyFilter(this.state.specialtyOptionsCheckboxs, "isOversizeWC");
				var isDialysis = getSpecialtyFilter(this.state.specialtyOptionsCheckboxs, "isDialysis");
				var fromDateTime = getDateTimeFilter(this.state.fromToDateTimeValues, "fromDateTime");
				var toDateTime = getDateTimeFilter(this.state.fromToDateTimeValues, "toDateTime");
				const offset = this.state.csvTop * this.state.csvOffset;
				let trips = this.state.csvTrips;
				let newTrips = [];

				const params = {
					top: this.state.csvTop, offset: offset, state: stateFilter, sortBy: this.state.sortBy, 
					sortOrder: this.state.sortOrder, dueTimeBeforeTripLocalTime: toDateTime, dueTimeAfterTripLocalTime: fromDateTime,
					providerId: providerId, status: status, client: clientFilter, serviceLevel: levelFilter, isVip: isVip, 
					WheelchairType: isOversizeWC, dialysis: isDialysis
				}
				
				Object.keys(params).forEach((key) => (params[key] == null || params[key] === '') && delete params[key]);
	
				if (this.state.selectedProvider === null) {
					AppToaster.show({ message: 'Provider is required.', intent: "danger", timeout: '7000', icon: ERROR_TOAST_ICON });
					return;
				}

				newTrips = await getTrips(params);

				trips = trips.concat(newTrips);

				this.setState({
					csvOffset: this.state.csvOffset + 1,
					csvTrips: trips,
					allTripsSearched: newTrips.length < this.state.csvTop || trips.length < this.state.csvTop || trips.length >= 5000 ? true : false,
				});
			}
			catch (error) {
				console.log(error);
				AppToaster.show({ message: 'There was an error while exporting, please try again.', intent: "danger", timeout: '7000', icon: ERROR_TOAST_ICON });
				break;
			}
		}
		this.setState({ csvLoading: false });
		this.csvLink.current.link.click();
	}

	render() {
		var tripsCount = this.state.trips.length;

		return (
			<div style={providerTripsContainer}>
				{this.state.isLoading ? <LoadingSpinner /> : <></>}
				<div style={tripsHeaderContainer}>
					<div style={tripsHeaderSubcontainer(this.props.themeName === Classes.DARK)}>
						<div style={flexCenter}>
							<span style={tripsSpan}>Trips: {tripsCount}</span>
							<div style={popoverContainerDiv}>
								<FilterModal fatherComponent={this} />
							</div>
						</div>
						<div style={refreshButtonContainer}>
							{this.state.trips.length !== 0 ?
								<div style={csvLinkContainer}>
									<Button onClick={this.exportCsv} loading={this.state.csvLoading} style={exportFileButton} intent={'primary'} icon="export" />
									<CSVLink
										filename={this.getCsvFilename()}
										data={this.state.csvTrips}
										headers={CSV_CONFIG.headers}
										ref={this.csvLink}
										enclosingCharacter={CSV_CONFIG.enclosingCharacter}
										separator={CSV_CONFIG.separator} >
									</CSVLink>
								</div> : null
							}
							<TripStatusFilterModal fatherComponent={this} />
							<div style={suggestContainer}>
								<SuggestProviderComponent style={suggestProviderComponentStyle} onChange={this.handleProviderChange} />
							</div>
							<Button style={searchButtonWidth} icon="add" text="Search" onClick={() => this.refreshTrips(this.state.sortBy, this.state.sortOrder)} />
						</div>
					</div>

					<div className="container" ref={(ref) => this.scrollParentRef = ref} onScroll={this.handleScroll}>
						<InfiniteScroll
							loadMore={this.handleLoadMore}
							hasMore={!this.state.isLoadMoreDisabled}
							threshold={100}
							useWindow={true}
							getScrollParent={() => this.scrollParentRef}
						>
							<div className="mt-5 mx-auto" ref={this.state.tableRef}>
								<ProvidersTripsTable
									trips={this.state.trips}
									themeName={this.props.themeName}
									setSelectedTrip={this.setSelectedTrip}
									selectedTrip={this.state.selectedTrip}
									refreshTrips={this.refreshTrips}
									customFields={this.state.trips?.customFields}
								/>
							</div>
						</InfiniteScroll>
					</div>
					<footer style={footerButtonsContainer}>
						<Button style={backToTopButton} icon="arrow-up" type="button" onClick={this.handleBackToTopClick} text="Back to top" intent={'primary'} />
					</footer>
				</div>
				{
					this.state.selectedTrip === null ? <div></div> :
						<TripsDetailsComponent
							selectedTrip={this.state.selectedTrip}
							handleKeySpinner={this.handleKeySpinner.bind(this)}
							isLoadingKeyEvents={this.state.isLoadingKeyEvents}
							isLoadingDetails={this.state.isLoadingDetails}
						/>
				}
			</div>
		)
	}
}
